import * as React from 'react';

import { Label } from '@/components/ui/label';
import { Popover, PopoverContent } from '@/components/ui/popover';

import { useMultiSelect } from '../model/use-multi-select';
import type { MultiSelectFilterProps } from '../model/types';

import { FilterTrigger } from './filter-trigger';
import { FilterContent } from './filter-content';
import { FilterSkeleton } from './filter-skeleton';

export function MultiSelectFilter({
  label,
  placeholder = 'Select items...',
  searchPlaceholder = 'Search...',
  emptyText = 'No items found',
  icon,
  groups,
  selectedItems,
  onItemsChange,
  isLoading = false,
  showSelectAll = true,
  maxDisplayItems = 3
}: MultiSelectFilterProps) {
  const [open, setOpen] = React.useState(false);

  const {
    selectedCount,
    isAllSelected,
    handleSelectAll,
    handleClearAll,
    handleToggleItem,
    isItemSelected,
    displayContent
  } = useMultiSelect(groups, selectedItems, onItemsChange, maxDisplayItems);

  if (isLoading) {
    return <FilterSkeleton label={label} />;
  }

  if (!groups || groups.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <Label>{label}</Label>
      <Popover open={open} onOpenChange={setOpen}>
        <FilterTrigger open={open} placeholder={placeholder} icon={icon} displayContent={displayContent} />
        <PopoverContent className="p-0 w-80" align="start">
          <FilterContent
            groups={groups}
            searchPlaceholder={searchPlaceholder}
            emptyText={emptyText}
            showSelectAll={showSelectAll}
            selectedCount={selectedCount}
            isAllSelected={isAllSelected}
            onSelectAll={handleSelectAll}
            onClearAll={handleClearAll}
            isItemSelected={isItemSelected}
            onToggleItem={handleToggleItem}
            defaultIcon={icon}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
